// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1JFgC","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__rQTVS"};